import React, { Component } from "react";
import "./AboutComponent.css";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";

class About extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="about-main">
        <Header theme={theme} />
        <div className="about-section" style={{ marginTop: '15px' }}>
          {/* Sección de descripción */}
          <Fade bottom duration={2000} distance="40px">
            <div className="description-container">
              <div className="description-images">
                <img
                  src={require("../../assests/images/reading.svg")}
                  alt="Reading Illustration"
                  className="image-bottom"
                />
                <img
                  src={require("../../assests/images/soccer.svg")}
                  alt="Soccer Illustration"
                  className="image-top"
                />
              </div>
              <div className="description-text">
                <h2 className="section-title" style={{ color: theme.text }}>About Me</h2>
                <p className="description-text-small" style={{ color: theme.secondaryText }}>
                  I am a developer and data scientist passionate about exploring new technologies 
                  and solving complex problems. I strive to create meaningful impact through projects 
                  that leverage data-driven insights for real-world decision-making. I continuously 
                  seek to expand my knowledge in technology, statistics, and analytics while sharing 
                  what I learn with others.
                </p>
                <p className="description-text-small" style={{ color: theme.secondaryText }}>
                  As an analytical and disciplined individual, I excel at breaking down complex 
                  challenges into actionable steps to achieve clear goals. While naturally introverted,
                  I value teamwork and the exchange of ideas to gain fresh perspectives and maximize 
                  outcomes. My curiosity drives me to explore new concepts, while my creativity helps 
                  me think outside the box and develop innovative solutions. Engaging in conversations 
                  about the latest technological trends and life's deeper topics is something I truly 
                  enjoy.
                </p>
                <p className="description-text-small" style={{ color: theme.secondaryText }}>
                  Beyond my programming expertise, I have a wide range of interests, including sports, 
                  video games, rock and mountain climbing, cinema, reading, and discovering new cuisines. 
                  Currently, I am pursuing a degree in Data Science at ITAM and am eager to embark 
                  on a professional career in technology and data analytics.
                </p>
              </div>
            </div>
          </Fade>

          {/* Interests Section */}
          <Fade bottom duration={2000} distance="40px">
            <div className="interests-container">
              <h2 className="section-title_1" style={{ color: theme.text }}>Interests</h2>
              <div className="interests-grid">
                <div className="interest-item-large">
                  <div className="interest-icon-large">
                    <img src={require("../../assests/images/coding.svg")} alt="Coding" />
                  </div>
                  <div>
                    <h3 style={{ color: theme.text }}>Coding</h3>
                    <p style={{ color: theme.secondaryText }}>
                      Building projects and solving problems.
                    </p>
                  </div>
                </div>
                <div className="interest-item">
                  <div className="interest-icon">
                    <img src={require("../../assests/images/gaming.svg")} alt="Gaming" />
                  </div>
                  <div>
                    <h3 style={{ color: theme.text }}>Gaming</h3>
                    <p style={{ color: theme.secondaryText }}>
                      Immersing myself in virtual worlds.
                    </p>
                  </div>
                </div>
                <div className="interest-item">
                  <div className="interest-icon">
                    <img src={require("../../assests/images/climbing1.svg")} alt="Climbing" />
                  </div>
                  <div>
                    <h3 style={{ color: theme.text }}>Climbing</h3>
                    <p style={{ color: theme.secondaryText }}>
                      Reaching new heights every day.
                    </p>
                  </div>
                </div>
                <div className="interest-item-medium">
                  <div className="interest-icon-medium">
                    <img src={require("../../assests/images/sports.svg")} alt="Sports" />
                  </div>
                  <div>
                    <h3 style={{ color: theme.text }}>Sports</h3>
                    <p style={{ color: theme.secondaryText }}>
                      Staying active and enjoying teamwork.
                    </p>
                  </div>
                </div>
                <div className="interest-item">
                  <div className="interest-icon">
                    <img src={require("../../assests/images/eating.svg")} alt="Eating" />
                  </div>
                  <div>
                    <h3 style={{ color: theme.text }}>Eating</h3>
                    <p style={{ color: theme.secondaryText }}>
                      Exploring flavors and cuisines.
                    </p>
                  </div>
                </div>
                <div className="interest-item">
                  <div className="interest-icon">
                    <img src={require("../../assests/images/cinema.svg")} alt="Cinema" />
                  </div>
                  <div>
                    <h3 style={{ color: theme.text }}>Cinema</h3>
                    <p style={{ color: theme.secondaryText }}>
                      Watching movies and storytelling.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Fade>

          {/* Achievements Section */}
          <Fade bottom duration={2000} distance="40px">
            <div className="achievements-container">
              <h2 className="section-title_1" style={{ color: theme.text }}>Achievements</h2>
              <div className="achievements-content">
                <div className="achievements-grid">
                  <div className="achievement-item">
                    <h3>National Climbing Championship 2011</h3>
                  </div>
                  <div className="achievement-item">
                    <h3>Regional Soccer Championship 2017</h3>
                  </div>
                  <div className="achievement-item">
                    <h3>Academic Excellence Award (ITAM)</h3>
                  </div>
                  <div className="achievement-item">
                    <h3>Academic Excellence Award (BAB)</h3>
                  </div>
                  <div className="achievement-item">
                    <h3>MAD Fellow — EPIC Lab ITAM</h3>
                  </div>
                  <div className="achievement-item">
                    <h3>Demo Day Winner &amp; Trepcamp Scholarship</h3>
                  </div>
                </div>
                <div className="achievements-image">
                  <img
                    src={require("../../assests/images/achievements.svg")}
                    alt="Achievements Illustration"
                  />
                </div>
              </div>
            </div>
          </Fade>
        </div>
        <TopButton theme={theme} />
        <Footer theme={theme} />
      </div>
    );
  }
}

export default About;
